<template>
<div style="margin-left: auto; margin-right: auto; width: 100%; position: relative" id="hoodieleft">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 642 642" style="enable-background:new 0 0 642 642;" xml:space="preserve">
<g>
	<path class="body" d="M228.38,528.78c-3.23-1.73-5.11-4.58-6.39-7.86c-9.94-25.5-15.85-51.79-15.7-79.31
		c0.06-10.24,0.36-20.49-0.54-30.72c-0.67-7.59,1.32-14.99,1.99-22.49c0.8-8.9,1.57-17.81,2.48-26.7
		c1.76-17.25,3.31-34.52,6.09-51.65c1.64-10.12,2.02-20.36,2.97-30.55c1.2-12.86,1.39-25.85,3.97-38.54
		c1.53-7.52,2.14-14.96,2.03-22.66c-0.38-25.39,5.26-49.32,18.81-71.09c2.18-3.5,4.78-6.66,7.85-9.41c2.02-1.81,4.02-3.7,5.39-6
		c6.05-10.24,16.14-15.95,25.26-22.72c16.8-12.47,34.95-22.85,53.08-33.2c9.86-5.63,18.98-12.28,28.37-18.58
		c6.88-4.61,14.41-7.69,22.39-9.71c5.99-1.52,8.11-0.44,11.68,4.66c8.03,11.47,11.82,24.48,14.17,38.04
		c1.31,7.53,4.72,14.55,5.43,22.22c0.72,7.76,3.8,14.99,4.99,22.65c1.69,10.87,2.43,21.83,3.68,32.74
		c0.58,5.02,0.8,10.09,1.18,15.14c0.64,8.55-4.76,18.22-12.49,22.07c-2.66,1.32-5.02,3.35-8.26,3.44c-1.59,0.05-0.58,1.32-0.43,1.96
		c3.12,14.08,5.55,28.29,7.9,42.51c1.09,6.6,1.4,13.3,1.56,19.96c0.26,10.85,2.52,21.38,4.34,31.98c2.66,15.48,3.29,31.08,3.1,46.7
		c-0.15,12.43,0.64,24.78,2.06,37.09c1.65,14.23,3.11,28.47,4.52,42.73c1.67,16.88,0.64,33.63-1.63,50.26
		c-1.85,13.61-7.64,25.98-16.21,36.83c-3.82,4.84-9.44,6.54-15.35,7.34c-1.2-1.33-2.78-1.51-4.43-1.4
		c-3.94,0.25-7.88,0.52-11.82,0.78c0.26-2.66-0.62-5.48,0.73-7.97c3.28-6.04,5.2-12.25,5.47-19.31c0.41-10.68,0.63-21.36,0.13-31.99
		c-0.45-9.43-1.32-18.85-1.83-28.3c-0.73-13.47,2.1-26.72,1.63-40.22c-0.41-12-1.67-24.02-0.92-36.07
		c0.6-9.48-0.65-18.94-0.61-28.43c0.03-6.51-1.92-12.84-1.81-19.41c0.1-5.78-1.59-11.45-1.52-17.32c0.11-9.03-1.25-17.97-2.29-26.94
		c-0.78-6.73-1.43-13.53-0.74-20.31c1.26-12.29,0.82-24.59-1.04-36.69c-3.01-19.59-9.46-38.18-19.1-55.57
		c-2.98-5.37-6.06-10.74-11.19-14.42c-9.57-6.87-20.21-6.15-30.66-3.24c-13.22,3.67-22.64,12.62-29.2,24.37
		c-8.04,14.41-11.65,30.38-16,46.17c-4.09,14.83-5.63,29.64-5.01,44.86c0.41,10.12,0.67,20.25,0.64,30.37
		c-0.02,5.62,0.77,10.86,3.37,15.91c1.34,2.61,2.96,5.41,2.23,8.56c-1.47,6.4-1.45,12.91-0.82,19.3c1.42,14.46,1.3,28.99,2.41,43.46
		c0.69,9,0.79,18.05,1.46,27.06c0.2,2.74,0.13,5.61,1.27,8.25c3.67,8.49,4.01,17.55,4.34,26.57c0.27,7.61-0.17,15.26,0.17,22.86
		c0.19,4.25,0.68,8.46,0.71,12.76c0.08,13.8-0.9,27.58-0.82,41.38c0.04,6.3,0.85,12.43,3.86,18.09c-1.56,0.4-3.1,1.08-4.67,1.16
		C263.17,531.18,245.67,533.5,228.38,528.78z M222.44,370.92c0.3,0,0.6,0,0.9,0c0,4.31-0.31,8.64,0.05,12.92
		c1.71,19.86,6.26,39.3,8.88,59.02c1.53,11.45,6.56,21.52,12.01,31.47c1.26,2.3,2.55,3.26,5.08,1.74c1.26-0.76,2.79-1.1,4.22-1.58
		c1.56-0.52,1.69-1.15,0.59-2.45c-4.32-5.12-6.7-11.17-8.49-17.58c-2.22-7.99-3.85-16.09-5.43-24.23
		c-2.48-12.77-5.87-25.37-7.64-38.26c-0.93-6.72-1.7-13.42-3.88-19.88c-0.7-2.08-0.5-4.27-0.5-6.42c0-3.45,0.04-6.9,0.03-10.35
		c-0.01-2.03-0.8-2.63-2.51-1.23c-2.15,1.76-3.72,3.64-3.38,6.82C222.71,364.21,222.44,367.58,222.44,370.92z"/>
	<path class="solid" d="M228.38,528.78c17.29,4.73,34.79,2.4,52.24,1.48c1.57-0.08,3.11-0.76,4.67-1.16
		c2.02,4.02,4.03,8.05,6.07,12.06c1.86,3.66,4.21,6.9,8.19,9.7c-0.51-2.48,0.25-3.03,2.21-3.19c7.91-0.66,15.79-1.76,23.7-2.43
		c10.6-0.9,21.25-0.58,31.88-0.68c1.87-0.02,3.62,0.33,5.34,0.97c8.64,3.17,14.55-0.13,16.63-9.02c0.87-3.72,0.05-7.54,1.11-11.2
		c3.94-0.26,7.88-0.54,11.82-0.78c1.65-0.1,3.22,0.07,4.43,1.4c-1.1,11.74-0.65,23.49-0.29,35.24c0.14,4.48-0.78,5.84-5.22,6.68
		c-7.94,1.5-15.96,2.46-24.01,3.05c-1.79,0.13-2.28,0.76-2.41,2.46c-0.54,6.88-1.11,13.76-0.74,20.67c0.24,4.35-0.2,4.59-4.5,4.32
		c-15.07-0.96-30.16-1.03-45.26-0.4c-0.32,0.01-0.64,0.08-0.96,0.1c-9.17,0.65-9.27,0.45-8.95-8.71c0.15-4.19-0.17-8.4-0.73-12.58
		c-0.17-1.3-0.64-1.39-1.83-1.37c-13.9,0.28-27.81,0.48-41.71,0.69c-7.23,0.11-14.43-0.39-21.62-1.15
		c-0.32-0.03-0.65-0.06-0.96-0.12c-8.12-1.45-9.05-2.56-9.06-10.76C228.4,552.29,228.39,540.53,228.38,528.78z"/>
	<path class="sleeve" d="M380.41,525.3c-1.06,3.66-0.23,7.48-1.11,11.2c-2.09,8.88-7.99,12.19-16.63,9.02
		c-1.73-0.63-3.48-0.99-5.34-0.97c-10.63,0.1-21.27-0.22-31.88,0.68c-7.91,0.67-15.79,1.77-23.7,2.43
		c-1.96,0.16-2.72,0.71-2.21,3.19c-3.98-2.8-6.33-6.04-8.19-9.7c-2.04-4.01-4.05-8.04-6.07-12.06c-3.02-5.66-3.83-11.79-3.86-18.09
		c-0.08-13.8,0.9-27.57,0.82-41.38c-0.03-4.3-0.51-8.51-0.71-12.76c-0.35-7.61,0.1-15.25-0.17-22.86
		c-0.32-9.01-0.66-18.08-4.34-26.57c-1.14-2.63-1.07-5.51-1.27-8.25c-0.67-9.01-0.77-18.06-1.46-27.06
		c-1.11-14.47-0.99-29-2.41-43.46c-0.62-6.38-0.65-12.9,0.82-19.3c0.72-3.15-0.89-5.95-2.23-8.56c-2.59-5.05-3.38-10.29-3.37-15.91
		c0.03-10.12-0.23-20.25-0.64-30.37c-0.61-15.23,0.93-30.03,5.01-44.86c4.35-15.79,7.95-31.76,16-46.17
		c6.56-11.75,15.98-20.7,29.2-24.37c10.45-2.9,21.09-3.63,30.66,3.24c5.13,3.68,8.21,9.05,11.19,14.42
		c9.64,17.39,16.09,35.98,19.1,55.57c1.86,12.1,2.3,24.4,1.04,36.69c-0.7,6.78-0.04,13.58,0.74,20.31
		c1.04,8.96,2.4,17.91,2.29,26.94c-0.07,5.87,1.61,11.53,1.52,17.32c-0.11,6.57,1.84,12.9,1.81,19.41
		c-0.04,9.48,1.2,18.95,0.61,28.43c-0.76,12.05,0.5,24.07,0.92,36.07c0.46,13.5-2.36,26.74-1.63,40.22
		c0.51,9.45,1.39,18.87,1.83,28.3c0.5,10.64,0.28,21.32-0.13,31.99c-0.27,7.06-2.19,13.27-5.47,19.31
		C379.79,519.83,380.67,522.64,380.41,525.3z"/>
	<path class="pocket" d="M222.44,370.92c0-3.34,0.27-6.71-0.08-10.02c-0.33-3.18,1.23-5.06,3.38-6.82c1.72-1.4,2.51-0.8,2.51,1.23
		c0.02,3.45-0.03,6.9-0.03,10.35c0,2.15-0.21,4.34,0.5,6.42c2.18,6.46,2.96,13.16,3.88,19.88c1.78,12.89,5.17,25.49,7.64,38.26
		c1.58,8.13,3.21,16.23,5.43,24.23c1.78,6.41,4.17,12.46,8.49,17.58c1.1,1.31,0.97,1.93-0.59,2.45c-1.43,0.48-2.96,0.82-4.22,1.58
		c-2.52,1.53-3.81,0.57-5.08-1.74c-5.45-9.94-10.49-20.02-12.01-31.47c-2.63-19.73-7.17-39.17-8.88-59.02
		c-0.37-4.28-0.05-8.61-0.05-12.92C223.05,370.92,222.75,370.92,222.44,370.92z"/>
</g>
<g>
	<path class="single_stripe" d="M304.17,580.85c-1.43-1.56,0.43-4.21-1.83-5.49c2.36-2.04,0.23-4.37,0.41-6.55c0.22-2.68-0.94-3.63-3.79-3.62
		c-14.19,0.05-28.4,0.71-42.56-0.58c-9.18-0.83-18.5-1.39-26.38-7.1c-0.85-0.62-1.09,0.05-1.54,0.41
		c-0.02-6.12-0.03-12.23-0.05-18.35c6.15,4.99,13.57,6.11,21.1,6.89c8.7,0.9,17.4,0.2,26.1,0.12c6.24-0.06,12.49-0.22,18.73-0.34
		c1.83,1.2,2.71,3.58,5.09,4.1c0.28,1.25,0.58,2.5,0.82,3.76c0.5,2.64,0.16,5.96,1.66,7.75c1.85,2.21,5.23-0.09,7.95,0.17
		c0.43,0.04,0.86-0.01,1.29,0c16.68,0.12,33.37-0.32,50.05,0.53c4.16,0.21,4.14,0.14,3.81,4.39c-0.11,1.39-0.06,2.8-0.09,4.2
		c-0.27,3.44-0.55,6.88-0.82,10.32C344.14,581.26,324.15,581.05,304.17,580.85z"/>
	<path class="single_stripe" d="M395.99,552.95c-5.9,3.84-12.68,4.43-19.41,5.18c-2.77,0.31-5.57,0.43-8.35,0.64
		c-1.39,0.11-1.74-0.3-1.61-1.85c0.29-3.42,1.29-6.78,0.91-10.26c5.33,0.14,8.93-2.36,11-7.2c6.04,0.01,11.82-1.34,17.44-3.44
		C395.98,541.67,395.98,547.31,395.99,552.95z"/>
</g>
<g>
	<path class="double_stripe" d="M228.49,561.39c-0.22-3.82-0.26-7.63,0.07-11.45c-0.19,4.41,3.1,5.69,6.35,6.84
		c6.76,2.4,13.79,3.14,20.94,3.32c13.58,0.36,27.14-0.18,40.7-0.86c1.8-0.09,4.63,0.74,4.52-2.86c-0.02-0.76,0.96-0.7,1.58-0.75
		c3-0.25,6-0.63,9.01-0.71c14.54-0.35,29.09-0.26,43.63-0.33c8.27-0.04,16.46-0.61,24.67-1.14c5.56-0.36,11.15-1.21,16.01-4.39
		c0.23,2.59,0.49,5.18,0.04,7.77c-2.34,2.62-5.46,3.76-8.75,4.53c-6.21,1.46-12.53,1.97-18.89,2.08c-0.99,0.02-2.41-0.49-2.7,1.02
		c-0.37,1.96-1.79,1.52-3.01,1.54c-9.8,0.21-19.62-0.47-29.41,0.44c-10.89,1.01-22.04-2.18-32.71,2.08
		c-15.92,0.68-31.84,1.79-47.76,0.48C244.16,568.3,235.61,567.02,228.49,561.39z"/>
	<path class="double_stripe" d="M303.69,577.48c8.41,0.03,16.81,0.08,25.22,0.07c11.75-0.01,23.51-0.08,35.26-0.12
		c-0.01,3.72,0.61,7.47-0.49,11.14c-18.76,0.95-37.53,1.04-56.29,0.07c-1.12-0.06-2.4-0.52-3.01,0.99
		C304.15,585.58,303.92,581.53,303.69,577.48z"/>
	<path class="double_stripe" d="M228.51,536.74c5.21,3.4,11.11,4.76,17.15,5.04c14.54,0.67,29.05-0.16,43.52-1.68
		c0.52-0.05,1.01-0.3,1.51-0.46c1.45,3.58,3.85,6.53,6.33,9.41c-4.29,1.33-8.76,0.8-13.12,1.07c-13.18,0.8-26.4,1.8-39.6,0.24
		c-4.51-0.53-8.85-1.65-12.93-3.72c-0.97-0.49-2.04-1.58-2.83,0.24C228.18,543.5,228.25,540.12,228.51,536.74z"/>
	<path class="double_stripe" d="M395.94,540.67c-6.58,2.81-13.51,3.66-20.59,3.69c2.44-2.74,3.44-6.14,4.4-9.56
		c4.27-0.15,8.44-0.94,12.61-1.85c2.55-0.55,3.85-1.83,3.98-4.38C396.76,532.62,395.94,536.63,395.94,540.67z"/>
</g>
<image style="overflow:visible;" class="ms-filter" width="279" height="613" xlink:href="https://www.customvarsityapparel.com.au/customize/img/jacket_design/hoodie_left.png" transform="matrix(0.9502 0 0 0.9502 188.4432 33.7551)">
</image>
</svg>


<!-- leftSleeve  Letters Starts  -->
<div v-show="leftSleeve_id === 'leftSleeve_letters'" class="leftSleeve_box" style="display: block; fill: rgb(255, 255, 255);">
	<svg class="leftSleeve_container leftSleeve_letters_holder">
		<text dominant-baseline="central" text-anchor="middle" y="50%" x="50%" class="leftSleeve_letters">
			{{leftSleeve_letters}}
		</text>
	</svg>
</div>
<!-- leftSleeve  letetrs Ends  -->
<!-- leftSleeve Years Starts -->
<div v-show="leftSleeve_id === 'leftSleeve_years'" class="leftSleeve_box" style="display: block; fill: rgb(255, 255, 255);">
	<svg class="leftSleeve_container leftSleeve_years_holder">
		<text dominant-baseline="central" text-anchor="middle" y="50%" x="50%" class="leftSleeve_years">
			{{leftSleeve_years}}
		</text>
	</svg>
</div>
<!-- leftSleeve Years Ends -->
<!-- leftSleeve Logos Starts -->
<div v-show="leftSleeve_id === 'leftSleeve_logos'" class="leftSleeve_box" style="display: block; fill: rgb(255, 255, 255);">
	<img :src="leftSleeve_logos" alt="" class="leftSleeve_logos">
</div>
<!-- leftSleeve Logos Ends -->

</div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
	name: 'HoodieJacketLeft',
	created() {
		this.$store.watch( getters => getters.leftSleeve_id)
		this.$store.watch( getters => getters.leftSleeve_letters)
		this.$store.watch( getters => getters.leftSleeve_years)
		this.$store.watch( getters => getters.leftSleeve_logos)

	},
	computed: {
		...mapGetters({
			leftSleeve_id: 'leftSleeve_id',
			leftSleeve_letters: 'leftSleeve_letters',
			leftSleeve_years: 'leftSleeve_years',
			leftSleeve_logos: 'leftSleeve_logos',
			
		}),
	}
}
</script>
<style scoped>

.body{fill:transparent;}
.solid{fill:transparent;}
.sleeve{fill:transparent;}
.pocket{fill:transparent;}
.single_stripe{fill:transparent;}
.double_stripe{fill:transparent;}
.ms-filter{mix-blend-mode: multiply;}


.leftSleeve_box {
    padding-bottom: 10%;
    top: 25%;
    width: 10%;
	right: 44.0%;
	position: absolute;
    z-index: 1;
}
.leftSleeve_container {
    left: 50%;
    overflow: visible;
    position: absolute;
    text-transform: uppercase;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
	-webkit-text-stroke: 5px transparent;
}

.leftSleeve_letters_holder{
  	font-size: 2em;
	font-family: 'Athletic', sans-serif;
}
.leftSleeve_years_holder{
	font-size: 3em;
	font-family: 'Athletic', sans-serif;
}

.leftSleeve_letters{
  display: none;
  fill: #000;
  stroke-width: 8px;
  paint-order: stroke;
  stroke: transparent;		
}

.leftSleeve_years{
  display: none;
  fill: #fff;
  stroke-width: 8px;
  paint-order: stroke;
  stroke: #e22c09;		
}

.leftSleeve_logos{
  display: none;
  width: 100%;
}

</style>